import React from "react";
import "../styles/main.css";
import VFBr_right from "../assets/VFBr_right.png";
import { Link } from "react-router-dom";


export default function BroadcastCTA() {
return (
  <section className="w-full bg-black py-24 xl:py-20 lg:py-16 md:py-12 sm:py-10 px-24 xl:px-20 lg:px-10 md:px-8 sm:px-5">
    <div className="px-0 xl:px-8 lg:px-0 md:px-0 sm:px-0">
      <div className="relative overflow-hidden rounded-2xl bg-[#151515] px-6 py-24 xl:py-20 lg:py-16 md:py-14 sm:py-12 text-center">

        {/* YELLOW STRIPED IMAGE (RIGHT SIDE) */}
        <div className="sm:hidden md:hidden absolute inset-y-0 right-0 w-1/2">
          <img
            src={VFBr_right}
            alt="Background pattern"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Dark overlay */}
        <div className="absolute inset-0" />

        {/* CONTENT */}
        <div className="relative z-10 flex flex-col items-center text-center py-8 sm:py-4">

          <h2 className="font-[Norwester] text-white uppercase tracking-[2px] leading-tight
            text-[40px] xl:text-[34px] lg:text-[28px] md:text-[24px] sm:text-[22px]
            max-w-[900px] xl:max-w-[700px] lg:max-w-[540px] md:max-w-full sm:max-w-full mb-6 sm:mb-4">
            Strengthen Brand Loyalty Through Sport
          </h2>

          <p className="font-[Inter] text-white/80 leading-relaxed
            text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[14px]
            max-w-[965px] xl:max-w-[650px] lg:max-w-[500px] md:max-w-full sm:max-w-full mb-10 sm:mb-7">
            By inviting fans into campaigns and rewarding their participation, brands create lasting emotional ties. Vupop enables brands to activate fans, enrich campaigns and build loyalty at scale.
          </p>

          <Link to="https://manager.vupop.io/broadcaster/signup/subscription" target="_blank">
            <button className="font-[Norwester] bg-[#FFF528] hover:bg-[#FFF528]/70 transition-colors
              text-black font-[400] uppercase rounded-lg tracking-wide
              text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[14px]
              px-10 xl:px-8 lg:px-7 sm:px-6 py-2.5 sm:py-2">
              Get Started
            </button>
          </Link>

        </div>
      </div>
    </div>
  </section>
);
}